<template>
  <div class="active-indicator-badge absolute -top-1 -right-1">
    <span class="border-surface dark:border-surface-dark relative flex">
      <span
        class="absolute right-[50%] inline-flex size-4 translate-x-1/2 animate-ping rounded-full opacity-75"
        :class="toggle ? 'secondary' : 'surface'"
      />
      <span
        class="relative flex items-center justify-center rounded-full p-1"
        :class="toggle ? 'secondary' : 'surface'"
      >
        <span v-if="$slots.default" class="text-2xs size-2.5 leading-none font-bold">
          <slot />
        </span>
        <FontAwesomeIcon v-else-if="icon" :icon="icon" size="2xs" />
        <span v-else class="size-2" />
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

withDefaults(
  defineProps<{
    toggle?: boolean
    icon?: [string, string]
  }>(),
  {
    toggle: true
  }
)
</script>

<style lang="scss" scoped>
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes ping {
  75%,
  100% {
    transform: scale(1.75);
    opacity: 0;
  }
}
</style>
